<template>
  <div class="password-reset-verification">
    <div v-if="verifying" class="password-reset-verification-verifying">
      <a-spin :spinning="verifying" size="large" :tip="labels.verifying" />
    </div>
    <div v-else-if="has_error" class="password-reset-verification-content">
      <font-awesome-icon
        :icon="['fas', 'times-circle']"
        size="5x"
        :class="'danger'"
      />
      <p>{{ message }}</p>
      <div>
        <router-link class="btn-login" :to="{ name: 'login' }">{{
          labels.goToLogin
        }}</router-link>
      </div>
      <div>
        <router-link class="btn-home" :to="{ name: 'home' }">{{
          labels.goToHome
        }}</router-link>
      </div>
    </div>
    <PasswordResetForm v-else />
  </div>
</template>
<script>
import loadingMixin from "@/mixins/loadingMixin";
import labels from "@/utils/labels";
import { mapActions } from "vuex";
import PasswordResetForm from "@/components/PasswordResetForm.vue";
import { pageTitle } from "../../utils/utils";
export default {
  components: { PasswordResetForm },
  name: "PasswordResetVerification",
  mixins: [loadingMixin],
  metaInfo: {
    title: pageTitle(labels.passwordResetForm.verification),
    meta: [
      {
        name: "title",
        content: labels.appName,
      },
      {
        name: "description",
        content: labels.passwordResetForm.verification,
      },
    ],
  },
  data() {
    return {
      labels: labels.passwordResetForm,
      verifying: true,
      message: "",
      has_error: false,
    };
  },
  created() {
    this.verify();
  },
  methods: {
    ...mapActions("clientAuth", ["handlePasswordResetCodeVerify"]),
    async verify() {
      try {
        this.verifying = true;
        let code = this.$route.params.code;
        if (!code) {
          this.has_error = true;
          this.message = this.labels.invalidToken;
          this.verifying = false;
          return;
        }
        await this.handlePasswordResetCodeVerify(code);
        this.has_error = false;
        this.message = "";
      } catch (error) {
        this.message =
          error?.response?.data?.message ||
          error?.response?.message ||
          error.message;
        this.has_error = true;
      } finally {
        this.verifying = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/variable";
.password-reset-verification {
  text-align: center;
  padding: 20px;
  min-height: 100vh;
  width: 100%;
  background-color: var(--background);
  color: var(--text);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: "Exo 2", sans-serif;
  user-select: none;
  &-content {
    width: 600px;
    padding: 70px;
    background-color: var(--card-shop-bg);
    border-radius: 15px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-shadow: 0px 0px 10px var(--card-shop-shadow);
    gap: 10px;
    h1 {
      font-size: 3.5rem;
      color: var(--text);
      margin-bottom: 0;
    }
    p {
      font-size: 1.45rem;
      margin-bottom: 0px;
    }
    div {
      width: 210px;
      height: 40px;
      display: flex;
      flex-direction: column;
      .btn-home {
        color: var(--btn-text-secondary) !important;
        background-color: var(--btn-bg-secondary) !important;
        border: 1px solid var(--btn-bc-secondary) !important;
        padding: 10px 20px;
        border-radius: 5px;
        font-size: 0.85rem;
        margin-top: 20px;
        transition: all 0.5s ease;
        font-weight: 600;
        &:hover {
          color: var(--btn-text-secondary) !important;
          background-color: var(--btn-bg-secondary) !important;
          border-color: var(--btn-bc-secondary) !important;
        }
      }
      .btn-login {
        @extend .btn-home;
        color: var(--btn-text-primary) !important;
        background-color: var(--btn-bg-primary) !important;
        border: 1px solid var(--btn-bc-primary) !important;
        &:hover {
          color: var(--btn-text-primary) !important;
          background-color: var(--btn-bg-primary) !important;
          border-color: var(--btn-bc-primary) !important;
        }
      }
    }
    .fa-check-circle,
    .fa-times-circle {
      margin-bottom: 10px;
      color: color(c-hover);
      font-weight: 400;
      &.danger {
        color: color(danger) !important;
      }
    }
  }
  .ant-spin {
    color: color(--white);
  }
}
</style>
